// Navigation
$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }
});

$(document).ready(function () {
    if ($('.main-nav-item').length) {
        watchMainNav();
    }

    if ($('#navigator').length) {
        watchNav();
    }

    if ($('.no-link.carousel-link').length) {
        $('.no-link.carousel-link').each(function () {
            $(this).on('click', function (e) {
                e.preventDefault();
            });
        });
    }

    // $(this).on('click', function () {
    //     console.log('vw = ' + $(this))
    // });

    if ($('.blog-previews-container').length) {
        $('.blog-previews-container').each(function () {
            let $blogGlide = new Glide(".blog-previews-container", {
                type: "carousel",
                perView: 4,
                gap: 10,
                keyboard: true,
                breakpoints: {
                    1200: {
                        perView: 3
                    },
                    992: {
                        perView: 2
                    },
                    680: {
                        perView: 1
                    }
                }
            }).mount();
        });
    }

    if ($('.testimonials-glide-list').length) {
        $('.testimonials-glide-list').each(function () {
            new Glide(".testimonials-glide-list", {
                type: "carousel",
                perView: 2,
                keyboard: true,
                breakpoints: {
                    992: {
                        perView: 1
                    }
                }
            }).mount();
        });
    }

    // Change Recaptcha error message
    if ($('.field.nocaptcha .message.error').length) {
        changeErrMsg();
    }

    if ($('.error-block.resend-verification-email').length) {
        resendVerificationEmail();
    }

    if ($('.page-elements-bar-container').length) {
        watchElementNavBar();
    }
});

function watchElementNavBar() {
    let $elements = $('.element');
    let $eleBar = $('.elements-bar-container');
    let $navLinks = $eleBar.children('.page-element').children('a');
    let $elementObjects = {};

    $elements.each(function () {
        let $id = $(this).attr('id');

        $elementObjects[$id] = $(this).offset().top - $(window).scrollTop() - 100;
    });

    $navLinks.on('click', function (e) {
        $navLinks.each(function () {
            $(this).removeClass('active');
        })

        if (!$(this).hasClass('active')) {
            $(this).addClass('active');

            let $chosenDistance = $elementObjects[$(this).data('distance-key')]

            $('html, body').animate({
                scrollTop: $chosenDistance - 100 // Scroll down 300 pixels
            }, 0);
        }
    });

    $navLinks.each(function () {
        $(this).on('click', function (e) {
            if (!$(this).hasClass('active')) {
                $(this).addClass('active');
            }
        })
    });

    // console.log($elementObjects);

    // $(window).on('scroll', function () {
    // let $distanceFromTop = $(window).scrollTop();
    // console.log($distanceFromTop + 15)
    // console.log($elementObjects['e51'])
    // console.log($distanceFromTop + 15 >= $elementObjects['e51'])

    // $navLinks.each(function () {
    //     let $id = $(this).attr('href').split('#')[1];
    //
    //     console.log($distanceFromTop)
    //
    //     if ($distanceFromTop + 15 >= $elementObjects[$id] && !$(this).hasClass('active')) {
    //         $(this).addClass('active');
    //     } else if ($distanceFromTop - 15 <= $elementObjects[$id] && $(this).hasClass('active')) {
    //         $(this).removeClass('active');
    //     }
    // });
    // });
}

function resendVerificationEmail() {
    let targetArea = $('.error-block.resend-verification-email .element-container .content-element-btn-container');
    let target = targetArea.children('a');

    if (target.text() === 'Resend verification email') {
        target.on('click', function () {
            $.ajax({
                url: '/SignUp/resendVerificationEmail',
                method: 'POST',
                dataType: 'json',
                success: function (data) {
                    let results = JSON.parse(JSON.stringify(data));

                    if (results === 'success') {
                        targetArea.parent().append('<p class="message good">You have successfully been registered. ' +
                            'Please check your email for the verification link. In case you don\'t see it, ' +
                            'please check your spam and junk folders. You won\'t be able to see the map without ' +
                            'verifying your email first.</p>');
                    } else {
                        targetArea.parent().append('<p class="message bad">Something went wrong. Please try logging' +
                            'in first. If you are already logged in or the error persists, please contact us ' +
                            'at <a href="mailto:help@logicstudio.nz">help@logicstudio.nz</a></p>');
                    }
                }
            });
        });
    }
}

function changeErrMsg() {
    let targetParent = $('.nocaptcha')

    if (targetParent.children('.message.error').length) {
        let target = targetParent.children('.message.error');
        target.text('Verification failed. Please try to verify again.');
    }
}

function watchNav() {
    let $targets = $('.main-nav-item').find('i.toggler');

    $targets.on('click', function () {
        let $this = $(this).closest('.nav-item');

        $targets.each(function () {
            let $parent = $(this).parent();

            if ($parent.hasClass('show-children') && !$parent.is($this)) {
                $parent.removeClass('show-children');

                let $subNav = $parent.find('.nav-secondary');
                $subNav.height(0);
            }
        });

        $this.toggleClass('show-children');

        let $subNav = $this.find('.nav-secondary');

        if ($this.hasClass('show-children')) {
            $subNav.height('auto');
            let ht = $subNav.height();
            $subNav.height(0);
            $subNav.height(ht);
        } else {
            $subNav.height(0);
        }
    });
}

function watchMainNav() {
    let $targets = $('.main-nav-item');

    $targets.on('mouseenter', function () {
        let $target2 = $(this).children('.nav-secondary');

        $target2.on('mouseenter', function () {
            let $parent = $(this).parent();

            if (!$parent.hasClass('active')) {
                $parent.addClass('active')
            }
        })

        $target2.on('mouseleave', function () {
            let $parent = $(this).parent();

            if ($parent.hasClass('active')) {
                $parent.removeClass('active')
            }
        })
    });
}

$(document).ready(function () {
    $('.blog-search-input').on('input', function () {
        const searchTerm = $(this).val().toLowerCase().trim();
        const searchWords = searchTerm.split(/\s+/); // Split input into individual words

        // Iterate over all blog-items-list elements on the page
        $('.carousel-items-list').each(function () {
            const $blogList = $(this);
            const $blogItems = $blogList.find('.carousel-item');

            let hasVisibleItems = false;

            $blogItems.each(function () {
                const itemText = $(this).text().toLowerCase();
                // Check if all search words are present in the item's text
                const matchesAllWords = searchWords.every(word => itemText.includes(word));

                if (matchesAllWords) {
                    $(this).show();
                    hasVisibleItems = true;
                } else {
                    $(this).hide();
                }
            });

            // Add or remove no-results class based on visibility
            if (!hasVisibleItems) {
                $blogList.addClass('no-results');
            } else {
                $blogList.removeClass('no-results');
            }
        });
    });
});
